import { render, staticRenderFns } from "./DialogEditSession.vue?vue&type=template&id=515061ea"
import script from "./DialogEditSession.vue?vue&type=script&lang=js"
export * from "./DialogEditSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports